'use client';

import { Tag } from '@stereoagency/ui';
import useTranslation from 'next-translate/useTranslation';
import { defaultLanguage } from '@stereoagency/constants';
import { useState } from 'react';
import { findInKeyArray } from '@/utils';
import { DiseaseModal, diseaseModalQueryBuilder } from '@/components/modals/DiseaseModal';

const query = diseaseModalQueryBuilder.use();

type Props = {
  diseases: (typeof query)[1];
};

export default function GroupOrPlatformDiseases({ diseases }: Props) {
  const { lang } = useTranslation();

  const [diseaseOpen, setDiseaseOpen] = useState<
    (typeof diseases)[number] | null
  >(null);

  if (!diseases.length) {
    return null;
  }

  return (
    <div>
      <div className="flex flex-wrap -m-3">
        {diseases.map((disease) => {
          const name = disease.name
            ? findInKeyArray(disease.name, [lang, defaultLanguage.id])
            : null;

          if (!name?.value) {
            return null;
          }

          return (
            <Tag
              key={disease._id}
              size="md"
              variant="default"
              accentColor="--colors-red-700"
              className="m-3"
              onClick={(event) => {
                event.preventDefault();
                setDiseaseOpen(disease);
              }}
            >
              {name.value}
            </Tag>
          );
        })}
      </div>

      <DiseaseModal
        disease={diseaseOpen}
        onClose={() => setDiseaseOpen(null)}
      />
    </div>
  );
}
